<template>
  <div class="content mb-5">
    <t-sub-nav :items="tabNavItems" class="mb-5" />

    <b-row class="mb-6">
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          v-if="!loading"
          class="mb-3"
          label-for="name"
          :label="this.$t('Lookup URL / FQDN')"
          :state="$validateState($v.form.domain)"
        >
          <b-form-input
            data-test-id="tools-test-categorization-url"
            id="url"
            @blur="setValidationInput('domain', $event.target.value)"
            :state="$validateState($v.form.domain)"
            :placeholder="this.$t('Enter URL / FQDN')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.domain.maxLength">
              {{ $t("Must contain at most 200 characters.") }}
            </p>
          </template>
        </b-form-group>
      </b-col>
    </b-row>

    <transition name="fade" mode="out-in">
      <section v-if="Object.keys(contentData).length > 1 && !loading">
        <t-content-box
          :header="contentData.header"
          :items="contentData.items"
        ></t-content-box>
      </section>
    </transition>

    <t-save-button
      data-test-id="tools-test-categorization-test"
      btn-text="Test"
      :form-model="$v.form"
      :fetching="fetching"
      @submit="onSubmit"
    />
  </div>
</template>

<route>
{
  "name": "Customer Test Categorization"
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import TContentBox from "@/components/TContentBox";

export default {
  layout: "customer",
  components: {
    TContentBox,
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("tools", ["checkTestFiltering", "clearCache"]),

    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    async onSubmit() {
      this.fetching = true;
      this.contentData = {};

      try {
        await this.checkTestFiltering(this.form);
      } catch (err) {
        if (err.response) {
          this.displayToast({
            title: this.$t("Error"),
            message: err.response.data.error,
            duration: 2000,
            variant: "danger",
          });
        }
      } finally {
        this.fetching = false;
        this.$v.form.$reset();
        this.contentData.header = this.$t("Categorization Results");
        this.contentData.items = this.toolsTestFiltering;
        this.clearCache();
      }
    },
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("tools", ["toolsTestFiltering"]),
  },
  data: function () {
    return {
      loading: true,
      fetching: false,
      form: {
        domain: null,
      },
      contentData: {},
      tabNavItems: this.$secondaryNav.toolsNavItems.customer(),
    };
  },
  validations: {
    form: {
      domain: {
        required,
        maxLength: maxLength(200),
      },
    },
  },
  async created() {
    this.setPageTitle(this.$t("Tools"));
    this.loading = false;
  },
  beforeDestroy() {
    this.clearCache();
  },
  mounted() {
    this.setPageSubtitle([
      this.$t(
        "Use Test Categorization to check what category a domain belongs to and see if it is currently allowed or blocked by WebTitan."
      ),
    ]);
  },
};
</script>
